<template>
  <div class="index">
    <div class="nav centered">
      <router-link :to="{ name: item.name }" :key="item.name"
      active-class="is-active" class="nav-item is-tab"
      v-for="item in userMenu">{{item.title}}</router-link>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import router from '../../router'

export default {
  data () {
    return {
      userMenu: []
    }
  },
  name: 'DocumentsContainer',
  methods: {
    ...mapActions(['logout', 'publishData'])
  },
  computed: {
    ...mapState(['menu', 'user'])
  },
  created () {
    this.userMenu = this.menu.documents.filter(i => i.roles.includes(this.user.role))

    if (this.$route.name === 'DocumentsContainer') {
      let routeToPush = '';

      for (const menuItem of this.userMenu) {
        if (menuItem.name === 'License') {
          routeToPush = '/about/documents/license'
        }
        else if (menuItem.name === 'Documents') {
          routeToPush = '/about/documents/all'
        }
        else if (menuItem.name === 'InformationContainer') {
          routeToPush = '/about/documents/information'
        }

        if (routeToPush) {
          router.push(routeToPush)
          break;
        }
      }

    }
  }
}
</script>



// WEBPACK FOOTER //
// Index.vue?15242928